export const common = {
  "nav.home": "الرئيسية",
  "nav.about": "من نحن",
  "nav.services": "المنتجات",
  "nav.portfolio": "الحلول",
  "nav.contact": "اتصل بنا",
  "nav.startInvesting": "احصل على عرض سعر",
  "nav.investment": "أليبل للاستثمار",
  "nav.investmentDesc": "المجموعة القابضة الأم",
  "nav.robotics": "أليبل للروبوتيكس",
  "nav.roboticsDesc": "الروبوتيكس والأتمتة",

  "hero.badge": "بطاريات المستقبل",
  "hero.title1": "مُصمَّمة حول",
  "hero.title2": "احتياجاتك من الطاقة",
  "hero.subtitle": "أنظمة بطاريات ليثيوم من الجيل التالي",
  "hero.description": "نحن لا نبني البطاريات فحسب — بل نهندس البنية التحتية للطاقة في المستقبل. أنظمة عالية الأداء مصممة للصناعات التي لا تتحمل التوقف.",
  "hero.discoverMore": "استكشف الحلول",
  "hero.getInTouch": "احصل على عرض سعر",
  "hero.portfolioCompanies": "دورات الشحن",
  "hero.headquarters": "المقر الرئيسي",
  "hero.established": "تأسست",
  "hero.valueCreation": "أداء دورة حياة طويلة",
  "hero.scroll": "تمرير",
  "hero.strategicGrowth": "كفاءة عالية في الطاقة",
  "hero.uae": "الإمارات",

  "about.label": "من نحن",
  "about.title1": "حلول طاقة",
  "about.title2": "متقدمة",
  "about.description": "نبني أنظمة الطاقة التي تشغّل البنية التحتية الأكثر أهمية في العالم — مهندسة بدقة، مصممة للمستقبل.",
  "about.parentEntity": "التميز الهندسي",
  "about.parentEntityDesc": "قدرة هندسية شاملة من اختيار الخلايا وتكامل BMS إلى التصميم الميكانيكي والاختبار والتكامل الكامل للنظام. نقدم حلول بطاريات ليثيوم مبنية بدقة ومخصصة للأداء والسلامة والموثوقية ومتطلبات تطبيق العميل.",
  "about.uaeBased": "مقرها الإمارات",
  "about.uaeBasedDesc": "يقع مقرها في دبي، تخدم ALEBEL ENERGY قطاعات الاتصالات والصناعة واللوجستيات والطاقة المتجددة والتنقل ومراكز البيانات في الإمارات والأسواق الإقليمية بحلول بطاريات ليثيوم مخصصة متقدمة ودعم تقني محلي.",
  "about.activeOwnership": "الجودة والسلامة",
  "about.activeOwnershipDesc": "يخضع كل نظام بطاريات لاختبارات صارمة للشحن/التفريغ، واختبارات الأداء الحراري، واختبارات الحمل، والتحقق من حماية BMS لضمان أقصى قدر من السلامة والموثوقية والأداء الثابت.",
  "about.innovationFocus": "التكنولوجيا الذكية",
  "about.innovationFocusDesc": "أنظمة بطاريات جاهزة لإنترنت الأشياء مع إمكانات المراقبة والتحكم في الوقت الفعلي، تتميز بـ CAN Bus وRS485 والبلوتوث وتكامل BMS الذكي وتقنية CCS المتقدمة.",
  "about.investmentSectors": "الصناعات التي نخدمها",
  "about.learnMore": "اعرف المزيد عنا",
  "about.ceoQuote1": "في Alebel Energy، مهمتنا هي تقديم أنظمة بطاريات ليثيوم عالمية المستوى مصممة لتلبية أعلى معايير الأداء والكفاءة والموثوقية.",
  "about.ceoQuote2": "نقدم حلول طاقة قابلة للتخصيص الكامل مصممة وفق الاحتياجات الفريدة للصناعات المختلفة، مما يضمن أقصى قدر من السلامة والتشغيل الموثوق في كل تطبيق.",
  "about.ceoName": "محمد حمد العامري",
  "about.ceoTitle": "الرئيس التنفيذي",
  "about.alebelteam": "فريق Alebel Energy",

  "sector.energy": "البنية التحتية للاتصالات",
  "sector.technology": "التطبيقات الصناعية",
  "sector.manufacturing": "اللوجستيات ومناولة المواد",
  "sector.electronics": "الطاقة المتجددة",
  "sector.industrial": "التنقل الكهربائي",

  "services.label": "منتجاتنا",
  "services.title1": "حلول",
  "services.title2": "البطاريات",
  "services.description": "أنظمة بطاريات ليثيوم عالية الأداء مهندسة للموثوقية في كل صناعة",
  "services.evaluation": "وحدات بطاريات ليثيوم مخصصة",
  "services.evaluationDesc": "جميع وحدات البطاريات مصممة ومطورة وفقاً لمتطلبات العميل، بما في ذلك الجهد والسعة والحجم والاتصال واحتياجات التطبيق. باستخدام تقنية LiFePO4 المتقدمة، توفر حلولنا سلامة عالية ودورة حياة طويلة وأداءً موثوقاً وحماية BMS الذكية.",
  "services.dueDiligence": "أنظمة احتياطية للاتصالات",
  "services.dueDiligenceDesc": "حلول احتياطية متقدمة لبطاريات الليثيوم مصممة للبنية التحتية للاتصالات لضمان الطاقة المستمرة أثناء انقطاع التيار وعدم استقرار الشبكة. أنظمتنا مبنية بجهات اتصال جافة متكاملة وحماية BMS الذكية وشاشة TFT للمراقبة والتحكم في الوقت الفعلي.",
  "services.activeManagement": "بطاريات صناعية وبطاريات الرافعات الشوكية",
  "services.activeManagementDesc": "حلول بطاريات ليثيوم عالية الأداء مصممة للرافعات الشوكية وعربات الغولف والمعدات الصناعية، توفر طاقة موثوقة وشحناً سريعاً وإنتاجية عالية وسعة تفريغ عالية الأمبير للعمليات ذات الأحمال الثقيلة.",
  "services.valueCreation": "أنظمة تخزين الطاقة (ESS)",
  "services.valueCreationDesc": "حلول تخزين طاقة متقدمة بتصميم قابل للتطوير والتوسيع للتطبيقات السكنية والتجارية والصناعية ومراكز البيانات. مصممة للتكامل السلس مع أنظمة الطاقة الشمسية والشبكات الذكية وأجهزة UPS.",
  "services.forCompanies": "التنقل الكهربائي",
  "services.corporateServices": "الدراجات الكهربائية والسكوترات",
  "services.corporateDesc": "أنظمة بطاريات ليثيوم خفيفة الوزن ومتينة وفعالة مصممة لتطبيقات التنقل الكهربائي، بما في ذلك الدراجات عالية الأداء.",
  "services.corporate1": "حلول تنقل فعالة وصديقة للبيئة",
  "services.corporate2": "أداء بطارية طويل الأمد",
  "services.corporate3": "حلول طاقة موثوقة وعالية الكفاءة",
  "services.corporate4": "أنظمة بطاريات خفيفة الوزن ومتينة",
  "services.forIndividuals": "تكامل BMS",
  "services.entrepreneurSupport": "المراقبة الذكية",
  "services.entrepreneurDesc": "تتبع الجهد والتيار وحالة الشحن وحالة الصحة في الوقت الفعلي مع إمكانية المراقبة عن بُعد الجاهزة لإنترنت الأشياء.",
  "services.entrepreneur1": "المراقبة والتشخيص في الوقت الفعلي",
  "services.entrepreneur2": "أنظمة حماية ذكية",
  "services.entrepreneur3": "بروتوكولات اتصال CAN Bus وRS485",
  "services.entrepreneur4": "التوافق مع أنظمة العاكس الرائدة",
  "services.entrepreneur5": "واجهات عرض سهلة الاستخدام",
  "services.learnMore": "اعرف المزيد",

  "projects.label": "الحلول",
  "projects.title1": "قدراتنا",
  "projects.title2": "",
  "projects.description": "هندسة شاملة من اختيار الخلايا إلى التكامل الكامل للنظام في كل تطبيق",
  "projects.energy.title": "أنظمة بطاريات LiFePO4",
  "projects.energy.desc": "أنظمة عالية كفاءة الطاقة تحقق كفاءة 95-98% من خلال كيمياء خلايا ليثيوم محسّنة وتصميم مقاومة داخلية منخفضة وشحن ذكي يتحكم فيه BMS.",
  "projects.electronics.title": "الهندسة والتصميم",
  "projects.electronics.desc": "تصميم معمارية البطارية وتكامل BMS والتصميم الكهربائي مع القضبان والموصلات والتصميم الميكانيكي للغلاف.",
  "projects.construction.title": "ضمان الجودة",
  "projects.construction.desc": "اختبارات الشحن والتفريغ، واختبارات الأداء الحراري، واختبارات الحمل في ظروف حقيقية، والتحقق من حماية BMS قبل كل تسليم.",
  "projects.viewDetails": "عرض التفاصيل",
  "projects.investmentFocus": "التكنولوجيا والسلامة",
  "projects.investmentFocusDesc": "آليات سلامة متقدمة مدمجة في كل مستوى — حماية من الجهد الزائد ومراقبة درجة الحرارة وإدارة الحرارة وحماية على مستوى الأجهزة.",
  "projects.viewAll": "عرض جميع الحلول",

  "tag.energy": "LiFePO4",
  "tag.batterySystems": "أنظمة البطاريات",
  "tag.industrial": "صناعي",
  "tag.electronics": "BMS",
  "tag.iot": "إنترنت الأشياء",
  "tag.smartSystems": "المراقبة الذكية",
  "tag.construction": "ESS",
  "tag.infrastructure": "احتياطي الاتصالات",
  "tag.development": "التنقل الكهربائي",

  "values.label": "لماذا تختارنا",
  "values.title1": "نقاط قوتنا",
  "values.title2": "الأساسية",
  "values.description": "مبنية على الهندسة الدقيقة والسلامة وموثوقية الأداء على المدى الطويل",
  "values.integrity": "كفاءة طاقة عالية",
  "values.integrityDesc": "تحقيق كفاءة 98-99.5% من خلال كيمياء خلايا ليثيوم محسّنة وشحن وتفريغ ذكي يتحكم فيه BMS.",
  "values.longTerm": "دورة حياة طويلة",
  "values.longTermDesc": "15,000+ دورة شحن وعمر تشغيلي يتراوح بين 10-15+ سنة مع أداء ثابت وتدهور ضئيل.",
  "values.excellence": "موثوقية الأداء",
  "values.excellenceDesc": "مهندسة لتوفير إخراج ثابت حتى في ظروف التشغيل المستمرة والمطلوبة.",
  "values.innovation": "سلامة متقدمة",
  "values.innovationDesc": "حماية من الجهد الزائد والتيار الزائد والدائرة القصيرة، ومراقبة درجة الحرارة باستخدام حساسات NTC، وإدارة الحرارة.",
  "values.collaboration": "تخصيص مرن",
  "values.collaborationDesc": "تخصيص مرن للجهد والسعة، وأنظمة تيار عالي تصل إلى 300A+، وإمكانية التثبيت الفوري.",
  "values.quote": "الجودة والسلامة والقابلية للتوسع هي جوهر كل نظام بطاريات نصممه ونسلّمه.",
  "values.quote2": "البنية التحتية للطاقة في الغد تتطلب أنظمة لا تفشل أبداً — مبنية بدقة، مدفوعة بالابتكار، ومهندسة لتتجاوز كل تحدٍّ.",

  "cta.label": "تواصل معنا",
  "cta.title1": "أطلق طاقة",
  "cta.title2": "عملياتك مع Alebel Energy",
  "cta.description": "سواء كنت بحاجة إلى حل بطارية مخصص أو نظام احتياطي للاتصالات أو تخزين طاقة صناعي، فريقنا جاهز لهندسة الحل المناسب لك.",
  "cta.contactUs": "اتصل بنا",
  "cta.callNow": "اتصل الآن",
  "cta.phone": "الهاتف",
  "cta.email": "البريد الإلكتروني",
  "cta.website": "الموقع الإلكتروني",
  "cta.location": "الموقع",

  "footer.description": "نشغّل البنية التحتية للغد. نهندس أنظمة طاقة عالية الأداء مبنية لتدوم أطول وتؤدي أفضل وتعيد تعريف الموثوقية.",
  "footer.quickLinks": "روابط سريعة",
  "footer.portfolio": "الحلول",
  "footer.contact": "اتصل بنا",
  "footer.aboutUs": "من نحن",
  "footer.batteryEnergy": "وحدات بطاريات ليثيوم مخصصة",
  "footer.iotSmart": "تكامل BMS والمراقبة الذكية",
  "footer.infrastructure": "أنظمة احتياطية للاتصالات والصناعة",
  "footer.copyright": "© 2026 ALEBEL Energy. جميع الحقوق محفوظة.",
  "footer.privacy": "سياسة الخصوصية",
  "footer.terms": "شروط الخدمة",

  "language": "اللغة",
  "language.en": "English",
  "language.ar": "العربية",

  "aboutPage.breadcrumb.home": "الرئيسية",
  "aboutPage.breadcrumb.about": "من نحن",
  "aboutPage.hero.label": "من نحن",
  "aboutPage.hero.title1": "عن",
  "aboutPage.hero.title2": "ALEBEL ENERGY",
  "aboutPage.hero.description": "شركة حلول طاقة متقدمة مقرها الإمارات متخصصة في تصميم وهندسة وتجميع وتوريد وحدات بطاريات ليثيوم عالية الأداء وأنظمة تخزين الطاقة.",
  "aboutPage.story.title1": "قصتنا",
  "aboutPage.story.title2": "",
  "aboutPage.story.p1": "Alebel Energy شركة حلول طاقة متقدمة مقرها الإمارات متخصصة في تصميم وهندسة وتجميع وتوريد وحدات بطاريات ليثيوم عالية الأداء وأنظمة تخزين الطاقة.",
  "aboutPage.story.p2": "نقدم حلول طاقة مخصصة مصممة لتلبية المتطلبات التشغيلية للبنية التحتية للاتصالات والتطبيقات الصناعية واللوجستيات ومناولة المواد وأنظمة الطاقة المتجددة.",
  "aboutPage.story.p3": "تتخذ Alebel Energy من دبي مقراً لها، وتعمل عند تقاطع الهندسة المتقدمة وتحديات الطاقة الواقعية، وتقدم حلولاً قوية تقنياً وفعالة عملياً.",
  "aboutPage.story.p4": "تم تصميم أنظمة بطاريات الليثيوم لدينا مع التركيز على كفاءة طاقة عالية تصل إلى 95-98%، وأداء دورة حياة طويلة تبلغ 15,000+ دورة شحن، وموثوقية أداء ثابتة حتى في الظروف القاسية.",
  "aboutPage.story.p5": "مع التزام راسخ بالجودة والسلامة وقابلية التوسع، تدعم Alebel Energy المؤسسات في تحقيق أهداف كفاءة الطاقة والاستمرارية التشغيلية والاستدامة.",
  "aboutPage.established": "تأسست",
  "aboutPage.process.label": "عمليتنا",
  "aboutPage.process.title1": "العملية",
  "aboutPage.process.title2": "الهندسية",
  "aboutPage.process.step1.title": "تحليل المتطلبات",
  "aboutPage.process.step1.desc": "نبدأ بتحليل شامل لمتطلبات الطاقة والبيئة والمتطلبات التشغيلية لديك.",
  "aboutPage.process.step2.title": "تصميم النظام",
  "aboutPage.process.step2.desc": "تصميم كهربائي وميكانيكي مخصص وفق مواصفاتك — معمارية البطارية وBMS والأغلفة.",
  "aboutPage.process.step3.title": "النموذج الأولي والاختبار",
  "aboutPage.process.step3.desc": "تطوير النموذج الأولي يليه اختبارات صارمة للشحن/التفريغ والحرارة والحمل في ظروف حقيقية.",
  "aboutPage.process.step4.title": "الإنتاج والتسليم",
  "aboutPage.process.step4.desc": "عمليات تجميع موحدة وضبط جودة صارم والتحقق من الأداء قبل التسليم.",
  "aboutPage.values.label": "قيمنا",
  "aboutPage.values.title1": "المبادئ",
  "aboutPage.values.title2": "الأساسية",
  "aboutPage.values.integrity": "الجودة",
  "aboutPage.values.integrityDesc": "يخضع كل نظام لاختبارات صارمة وضبط جودة قبل التسليم.",
  "aboutPage.values.longTerm": "السلامة",
  "aboutPage.values.longTermDesc": "السلامة مدمجة في كل مستوى من مستويات التصميم مع آليات حماية متقدمة.",
  "aboutPage.values.excellence": "قابلية التوسع",
  "aboutPage.values.excellenceDesc": "تصاميم معيارية وقابلة للتوسع تنمو مع احتياجاتك التشغيلية.",
  "aboutPage.values.innovation": "الابتكار",
  "aboutPage.values.innovationDesc": "جاهز لإنترنت الأشياء، مراقبة ذكية، وتقنية BMS متقدمة في كل نظام.",
  "aboutPage.values.collaboration": "الموثوقية",
  "aboutPage.values.collaborationDesc": "إخراج ثابت مهندس للظروف التشغيلية المستمرة والمطلوبة.",
  "aboutPage.story.label": "مهمتنا",
  "aboutPage.story.heading1": "هندسة",              
  "aboutPage.story.heading2": "مستقبل الطاقة",

  "servicesPage.breadcrumb.home": "الرئيسية",
  "servicesPage.breadcrumb.services": "المنتجات",
  "servicesPage.hero.label": "ما نقدمه",
  "servicesPage.hero.title1": "منتجاتنا",
  "servicesPage.hero.title2": "",
  "servicesPage.hero.description": "أنظمة بطاريات ليثيوم عالية الأداء وحلول تخزين طاقة لكل صناعة.",
  "servicesPage.corporate.label": "أنظمة البطاريات",
  "servicesPage.corporate.title1": "حلول بطاريات",
  "servicesPage.corporate.title2": "مخصصة",
  "servicesPage.corporate.description": "أنظمة بطاريات ليثيوم قابلة للتخصيص الكامل مصممة ومجمّعة لتلبية متطلباتك الدقيقة في الجهد والسعة والتشغيل.",
  "servicesPage.corporate.item1.title": "وحدات LiFePO4",
  "servicesPage.corporate.item1.desc": "وحدات بطاريات ليثيوم مخصصة لاحتياجات الجهد والسعة المحددة",
  "servicesPage.corporate.item2.title": "احتياطي الاتصالات",
  "servicesPage.corporate.item2.desc": "طاقة موثوقة أثناء الانقطاعات مع إعادة شحن سريعة وقابلية توسع معيارية",
  "servicesPage.corporate.item3.title": "البطاريات الصناعية",
  "servicesPage.corporate.item3.desc": "بطاريات رافعة شوكية وصناعية عالية الأداء وخالية من الصيانة",
  "servicesPage.corporate.item4.title": "تخزين الطاقة (ESS)",
  "servicesPage.corporate.item4.desc": "ESS قابل للتوسع مع تكامل الطاقة الشمسية والشبكة الذكية",
  "servicesPage.corporate.item5.title": "بطاريات الإشعال",
  "servicesPage.corporate.item5.desc": "تيار ذروة يصل إلى 2000A، قابل للتخصيص لأنظمة 12V و24V",
  "servicesPage.individual.label": "التنقل الكهربائي",
  "servicesPage.individual.title1": "حلول",
  "servicesPage.individual.title2": "التنقل الكهربائي",
  "servicesPage.individual.description": "أنظمة بطاريات خفيفة الوزن وفعالة ومتينة للسكوترات الكهربائية والدراجات وتطبيقات التنقل.",
  "servicesPage.individual.item1.title": "بطاريات السكوتر الكهربائي",
  "servicesPage.individual.item1.desc": "أنظمة بطاريات خفيفة فعالة وصديقة للبيئة",
  "servicesPage.individual.item2.title": "بطاريات الدراجات الكهربائية",
  "servicesPage.individual.item2.desc": "طاقة طويلة الأمد وعالية الكفاءة للدراجات الكهربائية",
  "servicesPage.individual.item3.title": "تكامل BMS",
  "servicesPage.individual.item3.desc": "إدارة بطارية ذكية مع مراقبة في الوقت الفعلي",
  "servicesPage.individual.item4.title": "المراقبة الذكية",
  "servicesPage.individual.item4.desc": "تتبع الجهد والتيار وحالة الشحن والصحة في الوقت الفعلي جاهز لإنترنت الأشياء",
  "servicesPage.individual.item5.title": "تكوينات مخصصة",
  "servicesPage.individual.item5.desc": "تخصيص مرن للجهد والسعة لأي تطبيق",
  "servicesPage.cta.title1": "هل تحتاج إلى",
  "servicesPage.cta.title2": "حل بطارية",
  "servicesPage.cta.title3": "مخصص؟",
  "servicesPage.cta.description": "فريقنا الهندسي جاهز لتصميم وتسليم حل الطاقة المناسب لمتطلباتك المحددة.",
  "servicesPage.cta.button": "احصل على عرض سعر",

  "portfolioPage.breadcrumb.home": "الرئيسية",
  "portfolioPage.breadcrumb.portfolio": "الحلول",
  "portfolioPage.hero.label": "قدراتنا",
  "portfolioPage.hero.title1": "التميز",
  "portfolioPage.hero.title2": "الهندسي",
  "portfolioPage.hero.description": "هندسة شاملة من اختيار الخلايا إلى التكامل الكامل للنظام في قطاعات الاتصالات والصناعة واللوجستيات والطاقة المتجددة.",
  "portfolioPage.energy.title": "معمارية بطارية LiFePO4",
  "portfolioPage.energy.desc": "تصميم معمارية البطارية وتكامل BMS وأنظمة الاتصال والتصميم الكهربائي مع القضبان والموصلات والتصميم الميكانيكي للغلاف.",
  "portfolioPage.energy.fullDesc": "تقدم Alebel Energy قدرة تصميم معمارية بطارية كاملة لأنظمة LiFePO4. يتولى فريقنا كل شيء من اختيار الخلية وتصميم الوحدة إلى تكامل BMS والتصميم الكهربائي وأغلفة الإدارة الحرارية.",
  "portfolioPage.electronics.title": "التميز في التصنيع",
  "portfolioPage.electronics.desc": "توريد مكونات عالية الجودة وعمليات تجميع موحدة وإجراءات صارمة لضبط الجودة والتحقق من الأداء قبل التسليم.",
  "portfolioPage.electronics.fullDesc": "يتم تصنيع كل نظام بطاريات Alebel Energy باستخدام عمليات موحدة ومكونات عالية الجودة. يضمن ضبط الجودة الصارم والتحقق قبل التسليم أن كل وحدة تؤدي وفق المواصفات.",
  "portfolioPage.construction.title": "الخبرة الصناعية",
  "portfolioPage.construction.desc": "خبرة مثبتة في طاقة الاتصالات الاحتياطية وأنظمة تخزين الطاقة وتطبيقات البطاريات الصناعية والمشاريع التجارية والبنية التحتية.",
  "portfolioPage.construction.fullDesc": "تمتلك Alebel Energy خبرة صناعية عميقة في طاقة الاتصالات الاحتياطية وأنظمة تخزين الطاقة (ESS) وتطبيقات البطاريات الصناعية والمشاريع التجارية والبنية التحتية الكبيرة في الإمارات ودول الخليج.",
  "portfolioPage.keyFocus": "القدرات الرئيسية:",
  "portfolioPage.sectors.label": "الصناعات",
  "portfolioPage.sectors.title1": "الأسواق التي",
  "portfolioPage.sectors.title2": "نخدمها",
  "portfolioPage.sectors.energy": "الاتصالات",
  "portfolioPage.sectors.technology": "الصناعة",
  "portfolioPage.sectors.manufacturing": "اللوجستيات",
  "portfolioPage.sectors.electronics": "الطاقة المتجددة",
  "portfolioPage.sectors.industrial": "التنقل الكهربائي",
  "portfolioPage.cta.title1": "مستعد",
  "portfolioPage.cta.title2": "للبدء",
  "portfolioPage.cta.description": "تواصل مع فريقنا الهندسي لمناقشة متطلبات الطاقة لديك والحصول على حل مخصص.",
  "portfolioPage.cta.button": "اتصل بنا",
  "portfolioPage.tags.energy": "LiFePO4",
  "portfolioPage.tags.batterySystems": "أنظمة البطاريات",
  "portfolioPage.tags.industrial": "صناعي",
  "portfolioPage.tags.electricMobility": "التنقل الكهربائي",
  "portfolioPage.tags.electronics": "BMS",
  "portfolioPage.tags.iot": "إنترنت الأشياء",
  "portfolioPage.tags.smartSystems": "المراقبة الذكية",
  "portfolioPage.tags.rfCommunication": "CAN Bus",
  "portfolioPage.tags.construction": "ESS",
  "portfolioPage.tags.infrastructure": "احتياطي الاتصالات",
  "portfolioPage.tags.development": "بناء مخصص",
  "portfolioPage.tags.turnkeyProjects": "حلول متكاملة",

  "contactPage.breadcrumb.home": "الرئيسية",
  "contactPage.breadcrumb.contact": "اتصل بنا",
  "contactPage.hero.label": "تواصل معنا",
  "contactPage.hero.title1": "اتصل",
  "contactPage.hero.title2": "بنا",
  "contactPage.hero.description": "مستعد لمناقشة متطلبات الطاقة لديك؟ فريقنا الهندسي هنا لمساعدتك في تصميم الحل المناسب.",
  "contactPage.form.title": "أرسل لنا رسالة",
  "contactPage.form.success": "شكراً! تم إرسال رسالتك بنجاح.",
  "contactPage.form.name": "الاسم الكامل",
  "contactPage.form.namePlaceholder": "اسمك",
  "contactPage.form.email": "البريد الإلكتروني",
  "contactPage.form.emailPlaceholder": "بريدك@الإلكتروني.com",
  "contactPage.form.company": "الشركة",
  "contactPage.form.companyPlaceholder": "شركتك",
  "contactPage.form.subject": "الموضوع",
  "contactPage.form.subjectPlaceholder": "اختر موضوعاً",
  "contactPage.form.subjectInvestment": "استفسار بطارية مخصصة",
  "contactPage.form.subjectPartnership": "فرصة شراكة",
  "contactPage.form.subjectStartup": "استشارة تقنية",
  "contactPage.form.subjectGeneral": "استفسار عام",
  "contactPage.form.message": "الرسالة",
  "contactPage.form.messagePlaceholder": "أخبرنا عن متطلبات الطاقة لديك...",
  "contactPage.form.submit": "إرسال الرسالة",
  "contactPage.form.sending": "جارٍ الإرسال...",
  "contactPage.info.title": "معلومات الاتصال",
  "contactPage.info.description": "سواء كنت بحاجة إلى حل بطارية مخصص أو استشارة تقنية أو تريد معرفة المزيد عن منتجاتنا، نحن هنا للمساعدة.",
  "contactPage.info.phone": "الهاتف",
  "contactPage.info.email": "البريد الإلكتروني",
  "contactPage.info.website": "الموقع الإلكتروني",
  "contactPage.info.location": "الموقع",
  "contactPage.info.locationValue": "دبي، الإمارات العربية المتحدة",
  "contactPage.info.locationDesc": "مكتب رقم: 501، الطابق الخامس، مبنى ناسكو، صلاح الدين، دبي، الإمارات",
  "contact.address.line1": "مكتب رقم 501، الطابق الخامس،",
  "contact.address.line2": "مبنى ناسكو، صلاح الدين،",
  "contact.address.line3": "دبي، الإمارات العربية المتحدة",
  "contact.address.short": "مكتب 501، مبنى ناسكو، صلاح الدين، دبي، الإمارات",

  "investPage.hero.label": "حلول بطاريات مخصصة",
  "investPage.hero.title1": "احصل على",
  "investPage.hero.title2": "عرض سعر",
  "investPage.hero.description": "أخبرنا عن متطلبات الطاقة لديك وسيصمم فريقنا الهندسي الحل المناسب لك.",
  "investPage.form.title": "طلب عرض سعر",
  "investPage.form.name": "الاسم الكامل",
  "investPage.form.namePlaceholder": "اسمك",
  "investPage.form.email": "البريد الإلكتروني",
  "investPage.form.emailPlaceholder": "بريدك@الإلكتروني.com",
  "investPage.form.company": "الشركة",
  "investPage.form.companyPlaceholder": "شركتك",
  "investPage.form.message": "متطلبات الطاقة",
  "investPage.form.messagePlaceholder": "صف متطلبات الجهد والسعة والتطبيق لديك...",
  "investPage.form.submit": "طلب عرض سعر",
  "investPage.form.sending": "جارٍ الإرسال...",
  "investPage.form.success": "شكراً! تم إرسال طلب عرض السعر بنجاح.",
  "investPage.form.close": "إغلاق",
  "investPage.investments.agricultural": "وحدات بطاريات ليثيوم مخصصة",
  "investPage.investments.tourist": "أنظمة طاقة احتياطية للاتصالات",
  "investPage.investments.healthcare": "بطاريات صناعية وبطاريات رافعة شوكية",
  "investPage.investments.commercial": "أنظمة تخزين الطاقة (ESS)",
  "investPage.investments.technological": "حلول تكامل BMS",
  "investPage.investments.energy": "بطاريات السكوتر الكهربائي والدراجات",
  "investPage.investments.oil": "بطاريات الإشعال",
  "investPage.investments.industrial": "أنظمة المراقبة الذكية",
  "investPage.investments.educational": "استشارة هندسية مخصصة",

  "portfolioPage.rd.title": "المراقبة الذكية",
  "portfolioPage.rd.desc": "أنظمة جاهزة لإنترنت الأشياء",
  "portfolioPage.rd.fullDesc": "تتبع الجهد والتيار وحالة الشحن والصحة في الوقت الفعلي. إمكانية المراقبة عن بُعد مع بنية تحتية جاهزة لإنترنت الأشياء وواجهات عرض سهلة الاستخدام.",
  "portfolioPage.robotics.title": "أنظمة السلامة",
  "portfolioPage.robotics.desc": "حماية متقدمة",
  "portfolioPage.robotics.fullDesc": "حماية من الجهد الزائد والمنخفض، والتيار الزائد والدائرة القصيرة، ومراقبة درجة الحرارة باستخدام حساسات NTC، وإدارة الحرارة لمنع ارتفاع الحرارة.",
  "portfolioPage.device.title": "تكامل النظام",
  "portfolioPage.device.desc": "اتصال سلس",
  "portfolioPage.device.fullDesc": "بروتوكولات اتصال CAN Bus وRS485، والتوافق مع أنظمة العاكس الرائدة، وإمكانية التثبيت الفوري للتكامل السلس للنظام.",
  "portfolioPage.tags.research": "إنترنت الأشياء",
  "portfolioPage.tags.innovation": "المراقبة الذكية",
  "portfolioPage.tags.robotics": "السلامة",
  "portfolioPage.tags.automation": "الحماية",
  "portfolioPage.tags.ai": "BMS",
  "portfolioPage.tags.devices": "CAN Bus",
  "portfolioPage.tags.smartTech": "RS485",

  "productsPage.breadcrumb.home": "الرئيسية",
"productsPage.breadcrumb.products": "المنتجات",
"productsPage.hero.label": "منتجاتنا",
"productsPage.hero.title1": "حلول",
"productsPage.hero.title2": "البطاريات",
"productsPage.hero.description": "حيث تلتقي الكيمياء المتقدمة بالتصميم الذكي. أنظمة بطاريات مصممة للأداء الأعلى والأطول عمراً في أصعب البيئات.",
"productsPage.cta.label": "ابدأ الآن",
"productsPage.cta.title1": "تحتاج إلى",
"productsPage.cta.title2": "حل مخصص؟",
"productsPage.cta.description": "فريقنا الهندسي جاهز لتصميم وتسليم حل البطارية المناسب لمتطلباتك المحددة.",
"productsPage.cta.contact": "تواصل مع فريقنا",
"productsPage.cta.about": "تعرف علينا",
"productsPage.getQuote": "احصل على عرض سعر",

"product1.name": "وحدات بطاريات ليثيوم مخصصة",
"product1.category": "LiFePO4",
"product1.description": "مصممة لمتطلبات الجهد والسعة المحددة، تستخدم وحدات بطاريات الليثيوم لدينا تقنية LiFePO4 المتقدمة لأقصى قدر من السلامة والأداء العالي ودورة الحياة التشغيلية الطويلة.",
"product1.f1": "تصميم جهد وسعة محدد",
"product1.f2": "كيمياء LiFePO4 المتقدمة",
"product1.f3": "أداء دورة حياة طويلة",
"product1.f4": "تكامل BMS مخصص",
"product1.f5": "سلامة عالية واستقرار حراري",
"product1.f6": "دعم المراقبة الذكية والاتصال",
"product1.f7": "أداء موثوق في البيئات القاسية",

"product2.name": "أنظمة احتياطية للاتصالات",
"product2.category": "اتصالات",
"product2.description": "حلول احتياطية موثوقة لبطاريات الليثيوم مصممة للبنية التحتية للاتصالات، توفر طاقة مستمرة أثناء الانقطاعات مع إمكانية إعادة شحن سريعة وقابلية توسع معيارية.",
"product2.f1": "طاقة موثوقة أثناء الانقطاعات",
"product2.f2": "إمكانية إعادة الشحن السريعة",
"product2.f3": "تصميم معياري وقابل للتوسع",
"product2.f4": "مراقبة IoT عن بُعد",
"product2.f5": "نظام حماية BMS الذكي",
"product2.f6": "شاشة TFT للمراقبة والتحكم",
"product2.f7": "اتصال CAN Bus وRS485",
"product2.f8": "جهتا اتصال جافتان مدمجتان للإنذارات والتحكم",

"product3.name": "بطاريات صناعية وبطاريات رافعة شوكية",
"product3.category": "صناعي",
"product3.description": "حلول بطاريات ليثيوم عالية الأداء مصممة للرافعات الشوكية والمعدات الصناعية وعربات الغولف، توفر طاقة موثوقة وإنتاجية عالية مع تشغيل خالٍ من الصيانة.",
"product3.f1": "إخراج عالي الأداء",
"product3.f2": "سعة تفريغ عالية",
"product3.f3": "تشغيل خالٍ من الصيانة",
"product3.f4": "تصميم صناعي للأعمال الشاقة",
"product3.f5": "دورة حياة ممتدة",
"product3.f6": "إمكانية الشحن السريع",
"product3.f7": "نظام حماية BMS الذكي",
"product3.f8": "تشغيل موثوق في البيئات المطلوبة",

"product4.name": "أنظمة تخزين الطاقة (ESS)",
"product4.category": "ESS",
"product4.description": "حلول تخزين طاقة متقدمة بتصميم قابل للتطوير والتوسيع للتطبيقات التجارية والصناعية والبنية التحتية ومراكز البيانات. مصممة للتكامل السلس مع الألواح الشمسية وأجهزة UPS والشبكات الذكية.",
"product4.f1": "تصميم معياري قابل للتوسع",
"product4.f2": "جاهز للتكامل الشمسي",
"product4.f3": "متوافق مع الشبكة الذكية",
"product4.f4": "مراقبة IoT في الوقت الفعلي",
"product4.f5": "إدارة طاقة عالية الكفاءة",
"product4.f6": "تقنية LiFePO4 طويلة دورة الحياة",
"product4.f7": "سعة وميزات قابلة للتخصيص",
"product4.f8": "تكامل حماية BMS الذكية والاتصال",

"product5.name": "حلول تكامل BMS",
"product5.category": "أنظمة ذكية",
"product5.description": "حلول تكامل نظام إدارة البطارية (BMS) المتقدمة المصممة للمراقبة في الوقت الفعلي والتشخيص وحماية البطارية الذكية.",
"product5.f1": "تتبع الجهد والتيار في الوقت الفعلي",
"product5.f2": "أنظمة حماية ذكية",
"product5.f3": "بروتوكولات اتصال CAN Bus وRS485",
"product5.f4": "واجهات شاشة TFT سهلة الاستخدام",
"product5.f5": "مراقبة وتشخيص IoT عن بُعد",
"product5.f6": "موازنة الخلايا ومراقبة درجة الحرارة",
"product5.f7": "إشعارات الإنذار وحماية الأعطال",
"product5.f8": "تكامل BMS مخصص بناءً على متطلبات التطبيق",

"product6.name": "بطاريات السكوتر الكهربائي والدراجات",
"product6.category": "التنقل الكهربائي",
"product6.description": "حلول بطاريات ليثيوم فعالة وصديقة للبيئة بتصاميم خفيفة الوزن ومتينة للسكوترات الكهربائية والدراجات الكهربائية وتطبيقات التنقل عالية الأداء.",
"product6.f1": "تصميم خفيف الوزن ومدمج",
"product6.f2": "حلول تنقل صديقة للبيئة",
"product6.f3": "إمكانية الشحن السريع",
"product6.f4": "نظام حماية BMS الذكي",
"product6.f5": "أداء بطارية طويل الأمد",
"product6.f6": "إخراج طاقة موثوق وثابت",
"product6.f7": "أداء تفريغ عالٍ",
"product6.f8": "خيارات جهد وسعة قابلة للتخصيص",

"product7.name": "بطاريات الإشعال",
"product7.category": "إشعال",
"product7.description": "بطاريات ليثيوم عالية الأداء للإشعال مهندسة للسيارات والبحرية والمعدات الثقيلة التي تتطلب توصيل تيار عالي موثوق.",
"product7.f1": "تيار ذروة يصل إلى 2000A",
"product7.f2": "خيارات نظام 12V و24V",
"product7.f3": "تصميم سعة قابل للتخصيص",
"product7.f4": "أداء تشغيل بارد عالٍ",
"product7.f5": "إمكانية إعادة الشحن السريعة",
"product7.f6": "تصميم ليثيوم خفيف الوزن",
"product7.f7": "نظام حماية BMS الذكي",
"product7.f8": "توصيل طاقة تيار عالٍ موثوق",

"product8.name": "بطارية أدوات الطاقة",
"product8.category": "أدوات الطاقة",
"product8.description": "حلول بطاريات ليثيوم أيون عالية الأداء مصممة لأدوات الطاقة الاحترافية التي تتطلب توصيل طاقة موثوق ومتسق.",
"product8.f1": "سعة وجهد قابلان للتخصيص",
"product8.f2": "تقنية Max Lithium Li-Ion",
"product8.f3": "دورات إعادة شحن سريعة",
"product8.f4": "متوافق مع ماركات الأدوات الرئيسية",
"product8.f5": "أداء إخراج طاقة عالٍ",
"product8.f6": "تصميم خفيف الوزن ومتين",
"product8.f7": "تكامل نظام حماية ذكي",
"product8.f8": "دورة حياة تشغيلية طويلة",

"customCard.alebelenergy": "أليبل للطاقة",
'customCard.subtitle': 'مفتوح للتخصيص الكامل',
'customCard.badge': 'مخصص',
'customCard.description': 'حلول بطاريات مخصصة متقدمة مصممة لتلبية المتطلبات التقنية والأداء الدقيقة — من المفهوم إلى الإنتاج الكامل. نحن متخصصون في {prismatic} و{pouch} و{cylindrical} باستخدام تقنيات بطاريات الليثيوم من الجيل التالي.',
'customCard.prismatic': 'الخلايا المنشورية',
'customCard.pouch': 'خلايا الكيس',
'customCard.cylindrical': 'الخلايا الأسطوانية',
'customCard.f1': 'هندسة الخلية وشكل العامل',
'customCard.f2': 'مواصفات الجهد والسعة',
'customCard.f3': 'كيمياء الليثيوم وتقنية الطاقة',
'customCard.f4': 'التصميم الميكانيكي والهيكلي',
'customCard.f5': 'تكامل BMS والبروتوكولات',
'customCard.f6': 'إدارة الحرارة والسلامة',
'customCard.f7': 'تحسين الشحن والتفريغ',
'customCard.f8': 'شهادات خاصة بالتطبيق',
'customCard.sectors': 'ESS · التنقل الكهربائي · البحرية · الاتصالات · الصناعة · الروبوتات · الطاقة الاحتياطية · OEM',

  "product9.name": "وحدة بطارية بحرية بالحالة الصلبة",
"product9.category": "البحرية والدفاع",
"product9.description": "وحدات بطاريات LiFePO₄ بالحالة الصلبة مصممة للتطبيقات البحرية والدفاعية عالية الأداء. متوفرة بتهيئات 12 فولت و24 فولت و48 فولت بسعة قابلة للتخصيص، وحماية IP67، وتيار ذروة يصل إلى 2000 أمبير — لضمان أداء موثوق ومستقر حرارياً للقوارب واليخوت والأنظمة البحرية والعسكرية.",
"product9.f1": "تقنية خلايا LiFePO₄ بالحالة الصلبة",
"product9.f2": "تهيئات 12 فولت / 24 فولت / 48 فولت",
"product9.f3": "سعة قابلة للتخصيص",
"product9.f4": "درجة حماية IP67 مقاومة للماء",
"product9.f5": "تيار ذروة يصل إلى 2000 أمبير (0–60 ثانية)",
"product9.f6": "تصميم خفيف الوزن ومدمج",
"product9.f7": "نظام BMS ذكي مدمج",
"product9.f8": "استقرار حراري عالٍ وسلامة متفوقة",

'nav.companyProfile': 'ملف الشركة',
'contactPage.form.mobile': 'رقم الجوال',
};

export default common;